import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import ListingPageComponent from '../../components/ListingPageComponent';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import FiltersPartial from "./FiltersPartial.js";
import PAGES from "../../data/PagesConstants.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const navigate = useNavigate();
  const [filtersModel, setFiltersModel] = useState({
    status: ['accepted']
  });

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'NAME',
      attr: 'name',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Wallet Balance',
      attr: 'wallet_balance',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Firm',
      attr: 'firm',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Area Head',
      attr: 'area_head',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Activated at',
      attr: 'activated_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_fleet_owner_details.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onViewClick = (id) => {
    navigate(`/fleet_owners/${id}`)
  }

  return <ListingPageComponent
    key={PAGES.FleetOwnersListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.FleetOwnersListingPage.name)}
    breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Fleet Owners' }]}
    listingMutation={getApi('fleetOwners')}
    className="fleet-owner-listing-page"
    contentHeading="Fleet Owners List - Results"
    headers={headers}
    recordsKey="fleet_owners"
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={['ID', 'Name', 'Mobile Number']}
  />
};

export default Index;
